export default __webpack_public_path__ + "static/media/designer-portfolio.200cbfac.png";